import request from '@/utils/request'

const url = '/auth-service/knowledgebases'

export function page(params) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params: params
  })
}

export function view(id) {
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params: {}
  })
}

export function create(params) {
  return request({
    url: `${url}`,
    method: 'post',
    params: params
  })
}

export function update(params) {
  return request({
    url: `${url}/${params.id}`,
    method: 'put',
    params: params
  })
}

export function remove(id) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

export function published(params) {
  return request({
    url: `${url}/published/${params.id}/${params.enabled}`,
    method: 'post'
  })
}

export function addDoc(params) {
  return request({
    url: `${url}/add_doc`,
    method: 'post',
    params: params
  })
}

export function removeDoc(params) {
  return request({
    url: `${url}/remove_doc`,
    method: 'post',
    params: params
  })
}

export function splitDoc(params) {
  return request({
    url: `${url}/split_doc`,
    method: 'post',
    params: params
  })
}

export function trunkPage(params) {
  return request({
    url: `${url}/trunk_page`,
    method: 'get',
    params: params
  })
}
